<template>
  <aside class="sidebar" :class="{ collapsed: !menuOpen }">
    <div class="brand">
      <span class="brand-mark">GT</span>
      <div>
        <strong>Gestion Total</strong>
        <small>SaaS modular</small>
      </div>
    </div>

    <nav class="menu">
      <router-link to="/dashboard" @click="closeMenu">Panel base</router-link>
      <router-link to="/cuenta" @click="closeMenu">Mi cuenta</router-link>
      <router-link to="/seleccionar-empresa" @click="closeMenu">Empresa activa</router-link>
      <router-link to="/configuracion-inicial" @click="closeMenu">Configuracion inicial</router-link>

      <p class="menu-label">Operacion</p>
      <router-link v-if="hasModule('pos') && can('pos.access')" to="/pv" @click="closeMenu">Punto de venta</router-link>
      <router-link v-if="hasModule('pos') && (can('pos.access') || can('comandero.access'))" to="/comandero" @click="closeMenu">Comandero</router-link>
      <router-link v-if="hasModule('pos') && can('hr.manage')" to="/rh" @click="closeMenu">Recursos humanos</router-link>
      <router-link v-if="hasModule('pos') && can('hr.self')" to="/mi-rh" @click="closeMenu">Mis horas</router-link>
      <router-link v-if="hasModule('pos') && can('users.manage')" to="/admin/lealtad" @click="closeMenu">Lealtad</router-link>
      <router-link v-if="hasModule('pos') && can('users.manage')" to="/admin/lealtad/canjes" @click="closeMenu">Reporte de canjes</router-link>
      <router-link v-if="hasModule('warehouse') && can('warehouse.access')" to="/dashboard" @click="closeMenu">Almacen</router-link>
      <router-link v-if="hasModule('ecommerce') && can('ecommerce.access')" to="/dashboard" @click="closeMenu">Tienda en linea</router-link>

      <p class="menu-label">Administracion</p>
      <router-link v-if="can('users.manage')" to="/admin/invitaciones" @click="closeMenu">Invitaciones</router-link>
      <router-link v-if="can('sales.manage')" to="/admin/vendedores" @click="closeMenu">Vendedores</router-link>
      <router-link to="/chat" @click="closeMenu">WebSockets demo</router-link>
    </nav>

    <button class="logout" @click="logoutAndClose">Cerrar sesion</button>
  </aside>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: { menuOpen: { type: Boolean, required: true } },
  methods: {
    ...mapActions(['logout']),
    closeMenu() { this.$emit('close-menu'); },
    can(permission) { return this.$store.getters.hasPermission(permission); },
    hasModule(code) { return this.$store.getters.hasModule(code); },
    async logoutAndClose() {
      await this.logout();
      this.closeMenu();
      this.$router.push('/login');
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  position: fixed;
  top: 4.5rem;
  left: 0;
  bottom: 0;
  width: 17rem;
  z-index: 850;
  background: rgba(255,255,255,.86);
  border-right: 1px solid var(--gt-border);
  backdrop-filter: blur(16px);
  padding: 1rem;
  transition: transform .2s ease;
  display: flex;
  flex-direction: column;
}
.sidebar.collapsed { transform: translateX(-100%); }
.brand { display: flex; gap: .8rem; align-items: center; padding: .75rem; margin-bottom: 1rem; }
.brand-mark { width: 2.6rem; height: 2.6rem; border-radius: 14px; display: grid; place-items: center; background: var(--gt-primary); color: #fff; font-weight: 900; }
.brand small { color: var(--gt-muted); }
.menu { display: grid; gap: .35rem; overflow: auto; padding-bottom: 1rem; }
.menu-label {
  margin: .8rem .8rem .15rem;
  color: var(--gt-muted);
  text-transform: uppercase;
  font-size: .72rem;
  letter-spacing: .08em;
  font-weight: 900;
}
.menu a {
  text-decoration: none;
  color: var(--gt-text);
  padding: .85rem 1rem;
  border-radius: 16px;
  font-weight: 800;
}
.menu a.router-link-active, .menu a:hover { background: var(--gt-primary-soft); color: var(--gt-primary); }
.logout {
  margin-top: auto;
  border: 0;
  border-radius: 999px;
  padding: .85rem 1rem;
  background: #fff0ec;
  color: var(--gt-danger);
  font-weight: 900;
  cursor: pointer;
}
@media (max-width: 991px) { .sidebar { transform: translateX(-100%); } .sidebar:not(.collapsed) { transform: translateX(0); } }
</style>
